import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import s from './MatchSquadList.scss';
import CricketPlayerCard from '../CricketTeamList/CricketPlayerCard';
import { TOI_IMAGE_DOMAIN } from '../../../../../constants/index';

const MatchSquadList = props => {
  if (props) {
    const {
      matchSquadData,
      teamaid,
      teambid,
      teamashrt_name,
      teambshrt_name,
      teamaname,
      teambname,
      deviceType,
      thumbslist,
      isIpl,
      tournamentName,
    } = props;
    let squadTeamA;
    let squadTeamB;
    const setTeamData = teamid => {
      const squadTeamVal = [];
      const squadData =
        Array.isArray(matchSquadData) &&
        matchSquadData.length > 0 &&
        matchSquadData[teamid]?.squad;
      const squadDataLength = squadData && Object.values(squadData).length;
      if (squadDataLength && squadDataLength > 0) {
        delete squadData.desc;
        Object.keys(squadData).forEach(key => {
          const items = {
            short_name: squadData[key][1],
            skill_name: squadData[key][2],
          };
          squadTeamVal.push(items);
        });
      }
      if (
        squadTeamVal &&
        Array.isArray(squadTeamVal) &&
        squadTeamVal.length === 0
      ) {
        const squadPlayerData =
          Array.isArray(matchSquadData) &&
          matchSquadData.length > 0 &&
          matchSquadData[0][teamid]?.player;
        return squadPlayerData;
      }
      return squadTeamVal;
    };
    const defaultThumb = `${TOI_IMAGE_DOMAIN}/thumb/msid-81945120,width-100,height-100/81945120.jpg`;
    if (teamaid) {
      squadTeamA = setTeamData(teamaid);
    }
    if (teambid) {
      squadTeamB = setTeamData(teambid);
    }
    const [showPlayer, setShowPlayer] = useState(true);
    const [showPlayer2, setShowPlayer2] = useState(true);

    return (
      <>
        {matchSquadData &&
          Array.isArray(matchSquadData) &&
          matchSquadData.length > 0 && (
            <div className={s.teamSquad}>
              <div className={s.heading}>
                <h2>
                  {teamashrt_name ? teamashrt_name.toUpperCase() : ''} vs{' '}
                  {teambshrt_name ? teambshrt_name.toUpperCase() : ''} Team
                  Squad
                </h2>
              </div>
              <div className={s.squadWrap}>
                {squadTeamA &&
                  Array.isArray(squadTeamA) &&
                  squadTeamA.length > 0 && (
                    <div className={s.team_page}>
                      <div className={s.team_players}>
                        <div className={s.team_details_block}>
                          <div className={s.player_bg} />
                          <div className={s.top_header}>
                            <div className={s.team_flag}>
                              <i
                                className={`${s.icon} ${
                                  s[
                                    teamashrt_name
                                      ? teamashrt_name.toUpperCase()
                                      : ''
                                  ]
                                }`}
                              />
                              {teamaname}
                            </div>
                            {/* <div className={s.score_ranking}>
                            <div className={s.rank}>{teamaranking}</div>
                            <div className={s.rank_text}>
                              {matchType} Ranking
                            </div>
                          </div> */}
                          </div>
                          <div className={s.players_block}>
                            <div className={s.player_wrap}>
                              {/* <div
                                className={`${s.player_details} ${s.heading}`}
                              >
                                Squad
                              </div> */}
                              {squadTeamA.map((items, index) => {
                                let playerkey = items && items.short_name;
                                playerkey =
                                  (playerkey &&
                                    playerkey
                                      .split(' ')
                                      .join('-')
                                      .toUpperCase()) ||
                                  null;
                                const showPlayerIndex =
                                  showPlayer && deviceType
                                    ? 6
                                    : squadTeamA.length;
                                if (index < showPlayerIndex) {
                                  return (
                                    <CricketPlayerCard
                                      items={items}
                                      playerkey={playerkey}
                                      thumbslist={thumbslist || ''}
                                      defaultThumb={defaultThumb}
                                      isIpl={isIpl}
                                      tournamentName={tournamentName}
                                    />
                                  );
                                }
                                return null;
                                // return getPlayerList(
                                //   items,
                                //   playerkey,
                                //   thumbslist,
                                //   defaultThumb,
                                // );
                              })}
                            </div>
                          </div>
                          <div className={s.view_full}>
                            {deviceType && (
                              <button
                                className="btn"
                                onClick={() => setShowPlayer(!showPlayer)}
                              >
                                {showPlayer
                                  ? 'See Full Squad'
                                  : 'Hide Full Squad'}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {squadTeamB &&
                  Array.isArray(squadTeamB) &&
                  squadTeamB.length > 0 && (
                    <div className={`${s.team_page}`}>
                      <div className={s.team_players}>
                        <div className={s.team_details_block}>
                          <div className={s.player_bg} />
                          <div className={s.dotted_bg_left} />
                          <div className={s.dotted_bg_bottom} />
                          <div className={s.top_header}>
                            <div className={s.team_flag}>
                              <i
                                className={`${s.icon} ${
                                  s[
                                    teambshrt_name
                                      ? teambshrt_name.toUpperCase()
                                      : ''
                                  ]
                                }`}
                              />
                              {teambname}
                            </div>
                            {/* <div className={s.score_ranking}>
                            <div className={s.rank}>{teambranking}</div>
                            <div className={s.rank_text}>
                               {rankingData?.comp_type} Ranking}
                              {matchType} Ranking
                            </div>
                          </div> */}
                          </div>
                          <div className={s.players_block}>
                            <div className={s.player_wrap}>
                              {/* <div
                                className={`${s.player_details} ${s.heading}`}
                              >
                                Squad
                              </div> */}
                              {squadTeamB.map((items, index) => {
                                let playerkey = items && items.short_name;
                                playerkey =
                                  (playerkey &&
                                    playerkey
                                      .split(' ')
                                      .join('-')
                                      .toUpperCase()) ||
                                  null;
                                const showPlayerIndex =
                                  showPlayer2 && deviceType
                                    ? 6
                                    : squadTeamB.length;
                                if (index < showPlayerIndex) {
                                  return (
                                    <CricketPlayerCard
                                      items={items}
                                      playerkey={playerkey}
                                      thumbslist={thumbslist || ''}
                                      defaultThumb={defaultThumb}
                                      isIpl={isIpl}
                                      tournamentName={tournamentName}
                                    />
                                  );
                                }
                                return null;
                                // return getPlayerList(
                                //   items,
                                //   playerkey,
                                //   thumbslist,
                                //   defaultThumb,
                                // );
                              })}
                            </div>
                          </div>
                          <div className={s.view_full}>
                            {deviceType && (
                              <button
                                className="btn"
                                onClick={() => setShowPlayer2(!showPlayer2)}
                              >
                                {showPlayer2
                                  ? 'See Full Squad'
                                  : 'Hide Full Squad'}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>
          )}
        {!matchSquadData && <div />}
      </>
    );
  }
};
MatchSquadList.propTypes = {
  matchSquadData: PropTypes.objectOf([]),
  deviceType: PropTypes.string,
  tournamentName: PropTypes.string,
};
MatchSquadList.defaultProps = {
  matchSquadData: [],
  deviceType: '',
  tournamentName: '',
};

export default MatchSquadList;
